import React from 'react'

import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import WhatsappIcon from 'assets/whatsapp-sticky.svg'
import mediaQueries from 'components/media-queries'
import NAMESPACES from 'localization/constants/namespaces'

const WhatsappIconContainer = styled.img`
  position: fixed;
  bottom: 40px;
  right: 5px;
  z-index: 9999;

  ${mediaQueries.mobile`
    right: 5px;
  `}
`

const StyledLink = styled.a`
  display: inline-block;
  position: fixed;
  bottom: 0;
  right: 5px;
  z-index: 9999;
  width: 72px;
  height: 72px;

  ${mediaQueries.mobile`
    right: 0px;
  `}
`

const StickyWhatsapp = () => {
  const { t } = useTranslation(NAMESPACES.HOME)

  return (
    <StyledLink href={t('whatsapp-api-contact.url')} target="_blank" rel="noopener noreferrer">
      <WhatsappIconContainer id="whatsapp_flotante" src={WhatsappIcon} alt={t('alt.whatsapp')} />
    </StyledLink>
  )
}

export default StickyWhatsapp
